import csvText from './players_with_photos.csv';
import nbaCsvText from './nbaplayers_with_photos.csv';
import moshCsvText from './notablealumni_with_photos.csv';
let cachedPlayers = null;
let cachedColleges = null;
let cachedNBAPlayers = null;
let cachedNBAColleges = null;
let cachedMoshPlayers = null;
let cachedMoshColleges = null;

export async function loadPlayers() {
  if (cachedPlayers) return cachedPlayers;

  const response = await fetch(csvText);
  const text = await response.text();

  const lines = text.trim().split('\n');
  const header = lines[0].split(',').map(h => h.trim());
  const dataLines = lines.slice(1);

  cachedPlayers = dataLines
    .map((line) => {
      const parts = line.trim().split(',');
      if (parts.length < 3) return null;

      const player = parts[0].trim();
      const college = parts[1].trim();
      const tier = parseInt(parts[2].trim(), 10);
      const espn_id = parts[3]?.trim() || '';
      const espn_type = parts[4]?.trim() || '';

      if (!player || !college) return null;

      return {
        player,
        college,
        tier: isNaN(tier) ? 3 : tier,
        espn_id,
        espn_type,
      };
    })
    .filter(Boolean);

  return cachedPlayers;
}

export async function loadColleges() {
  if (cachedColleges) return cachedColleges;

  const players = await loadPlayers();
  const collegeSet = new Set(players.map((p) => p.college));
  cachedColleges = Array.from(collegeSet).sort();

  return cachedColleges;
}



export async function loadNBAPlayers() {
  if (cachedNBAPlayers) return cachedNBAPlayers;

  const response = await fetch(nbaCsvText);
  const text = await response.text();

  const lines = text.trim().split('\n');
  const dataLines = lines.slice(1);

  cachedNBAPlayers = dataLines
    .map((line) => {
      const parts = line.trim().split(',');
      if (parts.length < 3) return null;

      const player = parts[0].trim();
      const college = parts[1].trim();
      const tier = parseInt(parts[2].trim(), 10);
      let espn_id = parts[3]?.trim() || '';
      let espn_type = parts[4]?.trim() || '';

      if (!player || !college) return null;

      // Pre-bake ESPN NBA photo URL so photoHelper works without changes
      if (espn_type === 'athlete' && espn_id && !espn_id.startsWith('http')) {
        espn_id = `https://a.espncdn.com/combiner/i?img=/i/headshots/nba/players/full/${espn_id}.png&w=200&h=145`;
        espn_type = 'custom';
      }

      return {
        player,
        college,
        tier: isNaN(tier) ? 3 : tier,
        espn_id,
        espn_type,
      };
    })
    .filter(Boolean);

  return cachedNBAPlayers;
}

export async function loadNBAColleges() {
  if (cachedNBAColleges) return cachedNBAColleges;
  const players = await loadNBAPlayers();
  const collegeSet = new Set(players.map((p) => p.college));
  cachedNBAColleges = Array.from(collegeSet).sort();
  return cachedNBAColleges;
}

export async function loadMoshPlayers() {
  if (cachedMoshPlayers) return cachedMoshPlayers;
  const response = await fetch(moshCsvText);
  const text = await response.text();
  const lines = text.trim().split('\n');
  cachedMoshPlayers = lines.slice(1).map(line => {
    const parts = line.split(',');
const category = parts[parts.length - 1]?.trim() || '';
    return {
      player: parts[0]?.trim(),
      college: parts[1]?.trim(),
      tier: isNaN(parseInt(parts[2])) ? 3 : parseInt(parts[2]),
      espn_id: parts[3]?.trim() || '',
      espn_type: parts[4]?.trim() || '',
      category: parts[parts.length - 1]?.trim() || '',
    };
  }).filter(p => p.player && p.college);
  return cachedMoshPlayers;
}

export async function loadMoshColleges() {
  if (cachedMoshColleges) return cachedMoshColleges;
  const players = await loadMoshPlayers();
  cachedMoshColleges = Array.from(new Set(players.map(p => p.college))).sort();
  return cachedMoshColleges;
}